import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import request from 'utils/request_ajax';

import MontserratSvg from 'images/font_family_montserrat.svg';
import ProximaNovaSvg from 'images/font_family_proxima_nova.svg';
import TisaSvg from 'images/font_family_tisa.svg';
import RobotoSvg from 'images/font_family_roboto.svg';

import StatusLabel from '../shared/StatusLabel';

const FONT_FAMILIES = {
  MONTSERRAT: 'montserrat',
  PROXIMA_NOVA: 'proxima-nova',
  TISA: 'ff-tisa-web-pro',
  ROBOTO: 'roboto',
};

const IMAGES = {
  [FONT_FAMILIES.MONTSERRAT]: MontserratSvg,
  [FONT_FAMILIES.PROXIMA_NOVA]: ProximaNovaSvg,
  [FONT_FAMILIES.TISA]: TisaSvg,
  [FONT_FAMILIES.ROBOTO]: RobotoSvg,
};

const FONT_FAMILY_NAMES = {
  [FONT_FAMILIES.MONTSERRAT]: t(
    'settings.tab.customization.font_family.montserrat',
  ),
  [FONT_FAMILIES.PROXIMA_NOVA]: t(
    'settings.tab.customization.font_family.proxima_nova',
  ),
  [FONT_FAMILIES.TISA]: t(
    'settings.tab.customization.font_family.ff-tisa-web-pro',
  ),
  [FONT_FAMILIES.ROBOTO]: t('settings.tab.customization.font_family.roboto'),
};

const SettingsFontFamily = ({ url, activeFontFamily, fontFamilies }) => {
  const [fontFamily, setFontFamily] = useState(activeFontFamily);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (success) {
      setTimeout(() => {
        setSuccess(false);
      }, 1500);
    }
  }, [success]);

  const updateFontFamily = e => {
    // Avoid sending request when not required
    if (e.target.value === fontFamily) {
      return;
    }

    setError(false);
    setFontFamily(e.target.value); // optimistic update
    const settings = { font_family: e.target.value };

    request
      .patchJSON(url, { company: { settings } })
      .then(() => {
        setFontFamily(settings.font_family);
        setSuccess(true);
      })
      .catch((response, statusText, err) => {
        console.error(err, response);
        setError(true);
        setFontFamily(fontFamily);
      });
  };

  return (
    <div className="controls mb-24">
      <div className="d-f mb-8">
        <p className="d-f ai-c jc-c mb-0 lh-24">
          {t('settings.tab.customization.font_family.title')}
        </p>
        <StatusLabel success={success} error={error} />
      </div>
      <div className="SettingsContent-radio d-f fw-w">
        {fontFamilies.map(family => (
          <Fragment key={family}>
            <input
              className="SettingsContent-radioInput"
              id={`company_settings_font_family_${family}`}
              type="radio"
              value={family}
              checked={family === fontFamily}
              onChange={updateFontFamily}
            />
            <label
              className="d-b c-p mr-32 mb-8"
              htmlFor={`company_settings_font_family_${family}`}
            >
              <span className="d-b ta-l mb-4">{FONT_FAMILY_NAMES[family]}</span>
              <img
                className={cn('SettingsContent-radioImage p-16', {
                  'SettingsContent-radio--selected': family === fontFamily,
                })}
                alt={family}
                src={IMAGES[family]}
              />
            </label>
          </Fragment>
        ))}
      </div>
    </div>
  );
};

SettingsFontFamily.propTypes = {
  url: PropTypes.string,
  activeFontFamily: PropTypes.oneOf(Object.values(FONT_FAMILIES)),
  fontFamilies: PropTypes.arrayOf(
    PropTypes.oneOf(Object.values(FONT_FAMILIES)),
  ),
};

export default props => <SettingsFontFamily {...props} />;
